import * as actionTypes from './actionTypes';
import axios from '../../axios-orders';


export const initOrder = () => {
    return {
        type: actionTypes.INIT_ORDER
    };
};

export const initSearchResults = () => {
    return {
        type: actionTypes.INIT_SEARCH_RESULTS
    };
};



export const updateOrder = (idToken, value) => {
    return {
        type: actionTypes.UPDATE_ORDER,
        idToken: idToken,
        value: value
    };
};


export const messageFail = (errorMessage) => {
    if (errorMessage === 'Security Exception') {
        return (dispatch) => {
            dispatch(logout());
        }

    }
    else {
        return {
            type: actionTypes.MESSAGE_FAIL,
            error: errorMessage,
            loading: false
        }
    }
};

export const loadStart = () => {
    return {
        type: actionTypes.LOAD_START
    };
};




export const sendDeliveryOut =(deliveryId) => {
    return (dispatch) => {
        let site = window.location.hostname;
        site = site.replace('drv', '');
        if (site === '') {
            site = 'local';
        }
        axios.get('http://api.mescout.org/api/Delivery/UpdateDeliveryStatus?site=' + site + '&status=delivering&deliveryId=' + deliveryId)
            .then(res => {
                dispatch(loadResult('delivery', res.data));
            })
            .catch(err => {
                dispatch(messageFail(err));
            });
    };
}


export const loadResult = (idToken, value) => {

    return {
        type: actionTypes.LOAD_RESULT,
        idToken: idToken,
        value: value
    };
};



export const signUpSuccess = (token, driverId) => {
    return {
        type: actionTypes.SIGNUP_SUCCESS,
        idToken: token,
        driverId: driverId
    };
};


export const logout = () => {
    localStorage.removeItem('driverToken');
    localStorage.removeItem('driverId');
  
    return {
        type: actionTypes.AUTH_LOGOUT
    };
};



export const auth = (phone, isSignup) => {
    return dispatch => {
        dispatch(loadStart());
        let site = window.location.hostname;
        site = site.replace('drv', '');
        if (site === '') {
            site = 'local';
        }
        let url = 'http://api.mescout.org/api/Security/LoginDriver?site=' + site + '&phone=' + phone;

        axios.post(url)
            .then(response => {
                if (response.data.driverId) {
                    localStorage.setItem('driverToken', response.data.SessionId);
                    localStorage.setItem('driverId', response.data.driverId);
                    dispatch(authSuccess(response.data.SessionId, response.data.driverId));
                    dispatch(getDelivery());        
                }
                else {
                    dispatch(messageFail('invalid user name or password'));
                }
            })
            .catch(err => {
                dispatch(messageFail(err.response.data.error));
            });
    };
};

export const authSuccess = (token, driverId) => {
    return {
        type: actionTypes.AUTH_SUCCESS,
        idToken: token,
        driverId: driverId
    };
};

export const signUp = (firstName, lastName,  phone, userName) => {
    return dispatch => {
        dispatch(loadStart());
        let site = window.location.hostname;
        site = site.replace('drv', '');
        if (site === '') {
            site = 'localhost';
        }
        let url = 'http://api.mescout.org/api/Security/SignUpDriver?site=' + site + '&firstName=' + firstName +
            '&lastName=' + lastName + '&phone=' + phone +
            '&userName=' + userName;
        console.log(url);
        axios.post(url)
            .then(response => {
                
                if (response.data.LoaderId) {
                    localStorage.setItem('driverToken', response.data.SessionId);
                    localStorage.setItem('driverId', response.data.DriverId);
                    dispatch(signUpSuccess(response.data.SessionId, response.data.LoaderId));

                }
                else {
                    console.log(response.data);
                    dispatch(messageFail(response.data));
                }
            })
            .catch(err => {
                console.log(err);
                dispatch(messageFail(err));
            });
    };
};


export const authCheckState = () => {
    return dispatch => {
        const token = localStorage.getItem('driverToken');
        if (!token) {
            dispatch(logout());
        } else {
            const driverId = localStorage.getItem('driverId');
            console.log("DRIVER LOGGED IN " + driverId);
            dispatch(authSuccess(token,driverId ));
            dispatch(getDelivery());
        }
    };
};


export const getDelivery = () => {

    return (dispatch, getState) => {
        let driverId = localStorage.getItem('driverId');
        console.log(driverId);
        //dispatch(loadStart());
        const { orders } = getState().orders;
        let site = window.location.hostname;
        site = site.replace('drv', '');
        if (site === '') {
            site = 'local';
        }
        axios.get('http://api.mescout.org/api/Delivery/GetAssignedDelivery?site=' + site +
            '&driverId=' + driverId)
            .then(res => {
                dispatch(loadResult('delivery', res.data));
            })
            .catch(err => {
                dispatch(messageFail(err));
            });
    };
};




// WEBPACK FOOTER //
// ./src/store/actions/orders.js